/**
 * @author Sky Lin
 * @date 2019/12/16
 */
const scrollToElement = domElement => {
  domElement.scrollIntoView({ block: 'end', behavior: 'smooth' });
};

export { scrollToElement };
